import { motion } from "framer-motion";
import { ABOUT_IMAGE, FALLBACK_IMG, REVEAL } from "@/lib/site";

const POINTS = [
  { title: "Factory-Direct Pricing", desc: "No showroom markups — you pay for timber, joinery and finish, nothing else." },
  { title: "Built To Your Measurements", desc: "Every piece can be tailored to your room dimensions and storage needs." },
  { title: "Seasoned, Treated Timber", desc: "Kiln-dried wood treated for Mumbai's coastal humidity and termites." },
  { title: "Mumbai · Navi Mumbai · Thane", desc: "Local workshop, local delivery team, local after-service you can reach." },
];

export const About = () => (
  <section id="about" data-testid="about-us-section" className="py-20 sm:py-28">
    <div className="section-shell grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <motion.div
        variants={REVEAL} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
        className="lg:col-span-5 relative"
      >
        <div className="absolute -bottom-4 -left-4 h-full w-full border border-brass/50 rounded-2xl pointer-events-none" />
        <div className="img-frame rounded-2xl aspect-[4/5] max-h-[70vh] w-full">
          <img
            src={ABOUT_IMAGE}
            onError={(e) => { e.currentTarget.src = FALLBACK_IMG; }}
            alt="Inside the JK Furniture woodworking workshop in Mumbai"
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </div>
      </motion.div>

      <div className="lg:col-span-7 lg:pl-6">
        <motion.p variants={REVEAL} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} className="eyebrow">
          04 / About Us
        </motion.p>
        <motion.h2
          variants={REVEAL} custom={1} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
          className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-walnut"
        >
          Born in Mumbai. <span className="italic text-teak">Obsessed With Wood.</span>
        </motion.h2>
        <motion.p
          variants={REVEAL} custom={2} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
          className="mt-6 text-base leading-relaxed text-stone-600"
        >
          JK Furniture designs and manufactures quality wooden furniture for homes across
          Mumbai, Navi Mumbai and Thane. We believe furniture should outlive trends — so we
          build with seasoned timber, honest joinery and modern designs that settle into
          your space like they were always meant to be there.
        </motion.p>
        <motion.p
          variants={REVEAL} custom={3} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
          className="mt-4 text-base leading-relaxed text-stone-600"
        >
          From wardrobes and beds to TV units and fully custom furniture, everything is
          made to order in our own workshops — which means durable construction,
          professional service and customer satisfaction you can hold us to, long after
          delivery day.
        </motion.p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-px overflow-hidden rounded-2xl border border-[#E7DFD5] bg-[#E7DFD5]">
          {POINTS.map((pt, i) => (
            <motion.div
              key={pt.title}
              data-testid={`about-metric-${i}`}
              variants={REVEAL} custom={i} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
              className="bg-white p-6"
            >
              <p className="font-serif text-lg text-walnut">{pt.title}</p>
              <p className="mt-2 text-sm leading-relaxed text-stone-600">{pt.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
